import { useStore } from "@/store";

export function resetIsGlobalNotesDisplayed() {
  const store = useStore();
  store.commit("timelineNotesViewer/resetIsGlobalNotesDisplayed");
}
